import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import TextField from "@material-ui/core/TextField";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import PostAddIcon from "@material-ui/icons/PostAdd";
import * as Dati from "../../../Dati";
import * as Glob from "../../../Globale";
import { Trad } from "../../../components";
import {_DateField, _NumberField, _Select} from "../../form";
import moment from "moment";
import {_Button} from "../common/Button";
import PrintIcon from "@material-ui/icons/Print";
import {_ButtonAPI} from "../common/ButtonAPI";
import useToggle from "../../../hooks/Toggle";
import {_RenewalActionDialog} from "../RenewalPoliciesList/ActionDialog";
import ChiamaWeb, {CChiamaWebParametri} from "../../../ChiamaWeb";
import {Globale, TTipiGlobale} from "../../../Globale";
import {onClickPrint, onPrint} from "./helpers";

interface IAddendaProps {
    BondData: Dati.CRisAPIDatoTipiInfo_Polizza;
    Data: Glob.DatiJSON;
    CoAssicurazioneJson: string;
    GetFormData: (calculate : boolean, newState: string) => Dati.CIngrAPI<Dati.CDatiPolizza>
    OnChange: (e: React.FormEvent<any> | string, val?: unknown) => void;
    OnClickSaveAddenda: (data: Dati.CRisAPI) => void;
    OnApiError: (error: Error) =>void;
}

const useStyles = makeStyles(({ shape, spacing, palette, typography }: Theme) => ({
    icon: {
        marginRight: spacing(2)
    },
    title: {
        flexGrow: 1,
    },
    toolbar: {
        background: palette.success.light,
        borderRadius: shape.borderRadius,
        color: palette.success.contrastText,
        marginTop: spacing(4),
        marginBottom: spacing(2)
    },
    removeBtn: {
        color: palette.error.main,
        background: "none"
    },
    divider: {
        marginTop: spacing(3),
        marginBottom: spacing(3)
    }
}));

export const _AddendaList: React.FC<IAddendaProps> = ({
     BondData, 
     Data, 
     CoAssicurazioneJson, 
     GetFormData, 
     OnChange, 
     OnClickSaveAddenda, 
     OnApiError
}) => {
    const classes = useStyles();
    const addenda: Dati.CAddendum[] = Data ? JSON.parse(Data) : [];
    const DatiPolizza = JSON.parse(BondData.Dato.DatiPolizza);
    const [typeAddendum, setTypeAddendum] = React.useState(false);
    
    const { open: openDelete, toggle: toggleDelete } = useToggle();
    const { open: openUpdate, toggle: toggleUpdate } = useToggle();
    const { open: openRelease, toggle: toggleRelease } = useToggle();
    
    const GetAddendumTypes = (temp: boolean): Dati.TDictTipo => {
        const addendumTypes: Dati.TDictTipo = {};
        addendumTypes["1"] = new Dati.CTipo("1", "AT-PrecisazioniCondizioniContrattuali");
        addendumTypes["2"] = new Dati.CTipo("2", "AT-VariazioneRischio");
        addendumTypes["3"] = new Dati.CTipo("3", "AT-VariazioneDati");
        if (!temp)
        {
            addendumTypes["4"] = new Dati.CTipo("4", "AT-Annullamento");
            addendumTypes["5"] = new Dati.CTipo("5", "AT-Proroga");
            addendumTypes["6"] = new Dati.CTipo("6", "AT-Svincolo");
            addendumTypes["7"] = new Dati.CTipo("7", "AT-Postuma");
            addendumTypes["8"] = new Dati.CTipo("8", "AT-AnnullamentoSeo");
            addendumTypes["9"] = new Dati.CTipo("9", "AT-DifferimentoDeiTermini");
        }
        addendumTypes["21"] = new Dati.CTipo("21", "AT-VariazioneRischioAumentoIG");
        addendumTypes["22"] = new Dati.CTipo("22", "AT-VariazioneRischioRiduzioneIG");
        addendumTypes["23"] = new Dati.CTipo("23", "AT-VariazioneRischioAumentoIGProroga");
        addendumTypes["24"] = new Dati.CTipo("24", "AT-VariazioneRischioRiduzioneIGProroga");
        addendumTypes["25"] = new Dati.CTipo("25", "AT-VariazioneRischioPerCambioContraenza");
        addendumTypes["30"] = new Dati.CTipo("30", "AT-SvincoloConPremio");
        return addendumTypes;
    };
    
    const addendumTypes: Dati.TDictTipo = GetAddendumTypes(typeAddendum);
    
    const OnDetailChange = (name: string, val: string, index: number, idAddendumType: string) => {idAddendumType
        if (name == 'DataInizio' || name == 'DataFine') {
            let data: moment.Moment = moment(val);
            if (BondData.Dato.DataInizioCopertura != undefined && data.toDate() < BondData.Dato.DataInizioCopertura) {
                val = moment(BondData.Dato.DataInizioCopertura).toJSON();
            }
        }
        if (name == 'ID_TipoAppendice') {
            if (val === '6') {
                addenda[index]['DataInizio'] = BondData.Dato.DataInizioCopertura ?? addenda[index]['DataEmissione'];
                addenda[index]['DataFine'] = addenda[index]['DataEmissione'];
            }
            if (BondData.Dato.ID_TipoProdotto === 5 || BondData.Dato.ID_TipoProdotto === 6 || BondData.Dato.ID_TipoProdotto === 30) {
                addenda[index]['TassoInteresseLegale'] = DatiPolizza.TassoInteresseLegale;
            }
            if (BondData.Dato.ID_TipoProdotto === 11) {
                addenda[index]['ContributoConsap'] = 0;
            }
        }
        
        addenda[index][name] = val;
        OnChange("Dato.AppendiciJSON", JSON.stringify(addenda));
    };
    
    const OnTempChange = (name: string, val: string, index: number, idAddendumType: string) => {
        if (val == "1")
            setTypeAddendum(true)
        else
            setTypeAddendum(false);
        OnDetailChange(name, val, index, idAddendumType);
    };
    
    const OnRemove = (index: number) => {
        addenda.splice(index, 1);
        OnChange("Dato.AppendiciJSON", JSON.stringify(addenda));
    };

    const OnAdd = () => {
        let addendum: Dati.CAddendum = new Dati.CAddendum()
        addendum.Numero = Math.max(...addenda.map(i => i.Numero), 0) + 1;
        addendum.DataFine = moment(BondData.Dato.DataFineCopertura).toDate()
        addendum.Accessori = DatiPolizza.Accessori;
        addenda.push(addendum);
        OnChange("Dato.AppendiciJSON", JSON.stringify(addenda));
    };
    
    const OnDelete = (id: number): void => {
        toggleDelete();
        const Param: CChiamaWebParametri = {
            Metodo: "POST",
            URL: `/api/addendum/Delete?idAddendum=${id}`,
            OnInvio: () => GetFormData(false, ""),
            OnRis: (sender, data) => OnClickSaveAddenda(data),
            OnErrore: (sender: ChiamaWeb, error: Error) => OnApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
    };
    
    const OnUpdate = (id: number): void => {
        const Param: CChiamaWebParametri = {
            Metodo: "POST",
            URL: `/api/addendum/Update?idAddendum=${id}`,
            OnInvio: () => GetFormData(false, ""),
            OnRis: (sender, data) => OnClickSaveAddenda(data),
            OnErrore: (sender: ChiamaWeb, error: Error) => OnApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
        toggleUpdate();
    };

    const OnRelease = (id: number): void => {
        toggleRelease();
        const Param: CChiamaWebParametri = {
            Metodo: "POST",
            URL: `/api/addendum/Release?idAddendum=${id}`,
            OnInvio: () => GetFormData(false, ""),
            OnRis: (sender, data) => OnClickSaveAddenda(data),
            OnErrore: (sender: ChiamaWeb, error: Error) => OnApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
    };
    
    const GetPolicyState = (idTypeAddendum: string): string =>
    {
        switch (idTypeAddendum) {
            case "4":
                return Glob.Tipi_PS_Annullata
            case "6":
                return Glob.Tipi_PS_Svincolata
            default:
                return "";
        }
    }
    
    const isDraft = BondData.Dato.ID_TipoPolizzaStato === Glob.Tipi_PS_PreventivoProroga
        || BondData.Dato.ID_TipoPolizzaStato === Glob.Tipi_PS_PreventivoVariata
        || BondData.Dato.ID_TipoPolizzaStato === Glob.Tipi_PS_PreventivoSvincolato
    const disableAddNew = BondData.Dato.ID_TipoPolizzaStato === Glob.Tipi_PS_Annullata 
        || BondData.Dato.ID_TipoPolizzaStato === Glob.Tipi_PS_Svincolata || isDraft
    
    return (
        <>
            <Toolbar variant="dense" className={classes.toolbar}>
                <PostAddIcon className={classes.icon} />
                <Typography variant="subtitle1" color="inherit" className={classes.title}>
                    {Trad.Trad("Appendici")}
                </Typography>
                <Tooltip title={Trad.Trad("Nuovo appendice")}>
                    <IconButton size="small" aria-label="add" onClick={OnAdd} disabled={disableAddNew}>
                        <AddIcon />
                    </IconButton>
                </Tooltip>
            </Toolbar>
            {addenda.map((detail: Dati.CAddendum, index: number) => (
                <div key={index}>
                    <Grid container spacing={4} justify="space-between" alignItems="center" key={index}>
                        <Grid item container xs={12} md={12} spacing={4}>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    id="Numero"
                                    label="Numero"
                                    value={detail.Numero}
                                    onChange={e => OnDetailChange(e.currentTarget.id, e.currentTarget.value, index, detail.ID_TipoAppendice)}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <FormControl component="fieldset">
                                    <RadioGroup
                                        row
                                        aria-label="gender"
                                        name="Temporanea"
                                        value={detail.Temporanea || "0"}
                                        onChange={e => OnTempChange(e.currentTarget.name, e.currentTarget.value, index, detail.ID_TipoAppendice)}
                                    >
                                        <FormControlLabel 
                                            disabled={Number(detail.ID_Appendice) > 0} 
                                            value="1" 
                                            control={<Radio />} 
                                            label={Trad.Trad("Temporanea")} />
                                        <FormControlLabel 
                                            disabled={Number(detail.ID_Appendice) > 0} 
                                            value="0" 
                                            control={<Radio />} 
                                            label={Trad.Trad("Non temporanea")} />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <_Select
                                    Disabled={Number(detail.ID_Appendice) > 0}
                                    Name="ID_TipoAppendice"
                                    Label="Tipo"
                                    Value={detail.ID_TipoAppendice || ""}
                                    OnChange={(name, val: string) => {OnDetailChange(name, val, index, detail.ID_TipoAppendice);}}
                                    Options={GetAddendumTypes(detail.Temporanea === '1')}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <_DateField
                                    Disabled={Number(detail.ID_Appendice) > 0 && !isDraft}
                                    Name="DataEmissione"
                                    Label="DataEmissione"
                                    Value={detail.DataEmissione}
                                    OnChange={(e, val) => OnDetailChange(e, moment(val).toJSON(), index, detail.ID_TipoAppendice)} />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <_DateField
                                    Disabled={Number(detail.ID_Appendice) > 0 && !isDraft}
                                    Name="DataInizio"
                                    Label="DataInizioCopertura"
                                    Value={detail.DataInizio}
                                    OnChange={(e, val) => OnDetailChange(e, moment(val).toJSON(), index, detail.ID_TipoAppendice)} />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <_DateField
                                    Disabled={Number(detail.ID_Appendice) > 0 && !isDraft}
                                    Name="DataFine"
                                    Label="DataFineCopertura"
                                    Value={detail.DataFine}
                                    OnChange={(e, val) => OnDetailChange(e, moment(val).toJSON(), index, detail.ID_TipoAppendice)} />
                            </Grid>

                                <Grid item xs={12} md={12}>
                                    <TextField
                                        rows={3}
                                        disabled={Number(detail.ID_Appendice) > 0 && !isDraft}
                                        value={detail.Testo}
                                        id="Testo"
                                        label={Trad.Trad("Testo")}
                                        onChange={e => OnDetailChange(e.currentTarget.id, e.currentTarget.value, index, detail.ID_TipoAppendice)}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                </InputAdornment>
                                            )
                                        }}
                                        fullWidth
                                    />
                                </Grid>
                                { (detail.ID_TipoAppendice == "2" || detail.ID_TipoAppendice == "4" || detail.ID_TipoAppendice == "5"
                                        || detail.ID_TipoAppendice == "21" || detail.ID_TipoAppendice == "22" 
                                        || detail.ID_TipoAppendice == "23" || detail.ID_TipoAppendice == "24") &&
                                    <>
                                        <Grid item xs={12} md={2} >
                                            <_NumberField
                                                Disabled={Number(detail.ID_Appendice) > 0 && !isDraft}
                                                Id="ImportoGarantito"
                                                Label="ImportoGarantito"
                                                Value={detail.ImportoGarantito ?? 0}
                                                OnChange={(e, val) => OnDetailChange(e, val, index, detail.ID_TipoAppendice)} />
                                        </Grid>
                                        { (BondData.Dato.ID_TipoProdotto === 5 || BondData.Dato.ID_TipoProdotto === 6) &&
                                            <Grid item xs={12} md={2} >
                                                <_NumberField
                                                    Disabled={Number(detail.ID_Appendice) > 0 && !isDraft}
                                                    Id="TassoInteresseLegale"
                                                    Label="TassoInteresseLegale"
                                                    Value={detail.TassoInteresseLegale ?? 0}
                                                    Max={100}
                                                    Min={0}
                                                    Adornment="%"
                                                    OnChange={(e, val) => OnDetailChange(e, val, index, detail.ID_TipoAppendice)} />
                                            </Grid>
                                        }
                                        { (BondData.Dato.ID_TipoProdotto === 11) &&
                                            <Grid item xs={12} md={2} >
                                                <_NumberField
                                                    Disabled={Number(detail.ID_Appendice) > 0 && !isDraft}
                                                    Id="ContributoConsap"
                                                    Label="ContributoConsap"
                                                    Value={detail.ContributoConsap ?? 0}
                                                    OnChange={(e, val) => OnDetailChange(e, val, index, detail.ID_TipoAppendice)} />
                                            </Grid>
                                        }
                                    </>
                                }
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <_NumberField
                                    Disabled={Number(detail.ID_Appendice) > 0 && !isDraft}
                                    Id="PremioNetto"
                                    Label="PremioNetto" 
                                    Value={detail.PremioNetto}
                                    OnChange={(e, val) => OnDetailChange(e, val, index, detail.ID_TipoAppendice)} />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <_NumberField
                                    Disabled={Number(detail.ID_Appendice) > 0 && !isDraft}
                                    Id="Accessori"
                                    Label="Accessori"
                                    Value={detail.Accessori}
                                    Max={100}
                                    Min={0}
                                    Adornment="%"
                                    OnChange={(e, val) => OnDetailChange(e, val, index, detail.ID_TipoAppendice)} />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <_NumberField
                                    Disabled={Number(detail.ID_Appendice) > 0 && !isDraft}
                                    Id="DirittiDiEmissione"
                                    Label="Diritti emissione"
                                    Value={detail.DirittiDiEmissione}
                                    OnChange={(e, val) => OnDetailChange(e, val, index, detail.ID_TipoAppendice)} />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <_NumberField
                                    Disabled={Number(detail.ID_Appendice) > 0 && !isDraft}
                                    Id="Imponibile"
                                    Label="Imponibile"
                                    Value={detail.Imponibile}
                                    OnChange={(e, val) => OnDetailChange(e, val, index, detail.ID_TipoAppendice)} />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <_NumberField
                                    Disabled={Number(detail.ID_Appendice) > 0 && !isDraft}
                                    Id="Imposte"
                                    Label="Imposte"
                                    Value={detail.Imposte}
                                    OnChange={(e, val) => OnDetailChange(e, val, index, detail.ID_TipoAppendice)} />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <_NumberField
                                    Disabled={Number(detail.ID_Appendice) > 0 && !isDraft}
                                    Id="PremioFinito"
                                    Label="PremioFinito"
                                    Value={detail.PremioFinito}
                                    OnChange={(e, val) => OnDetailChange(e, val, index, detail.ID_TipoAppendice)} />
                            </Grid>
                        {Number(detail.ID_Appendice) == 0 && (
                            <>
                                <Grid item>
                                    <Tooltip title={Trad.Trad("Elimina")}>
                                        <IconButton
                                            disableRipple
                                            className={classes.removeBtn}
                                            aria-label="remove"
                                            onClick={() => {OnRemove(index);}}
                                        >
                                            <DeleteIcon/>
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                            </>
                        )}
                        <Grid item container xs={12} spacing={3} justify="flex-start">
                            <_RenewalActionDialog
                                Open={openDelete}
                                Title={"Confirm"}
                                Message={`Eliminare l'appendice?`}
                                OnCancel={toggleDelete}
                                OnConfirm={() => OnDelete(Number(detail.ID_Appendice))}
                                OnClose={toggleDelete}
                            />
                            <_RenewalActionDialog
                                Open={openUpdate}
                                Title={"Confirm"}
                                Message={`Aggiornare l'appendice?`}
                                OnCancel={toggleUpdate}
                                OnConfirm={() => OnUpdate(Number(detail.ID_Appendice))}
                                OnClose={toggleUpdate}
                            />
                            <_RenewalActionDialog
                                Open={openRelease}
                                Title={"Confirm"}
                                Message={`Emettere l'appendice?`}
                                OnCancel={toggleRelease}
                                OnConfirm={() => OnRelease(Number(detail.ID_Appendice))}
                                OnClose={toggleRelease}
                            />
                            {Number(detail.Numero) > 0 && (
                                <Grid item xs={12} md={2}>
                                    <_ButtonAPI Testo={Trad.Trad("Stampa")} Icona={<PrintIcon/>}
                                                URL="/api/File/GetPolicyBondFiles"
                                                OnInvio={() =>  onPrint(true, BondData.Dato, false, false, detail.Numero)}
                                                OnClick={onClickPrint}
                                                OnErrore={OnApiError}/>
                                </Grid>
                            )}
                            {Number(detail.Numero) > 0 && (
                                <Grid item xs={12} md={2}>
                                    <_ButtonAPI Testo={Trad.Trad("Firma")} Icona={<PrintIcon/>}
                                                URL="/api/File/GetPolicyBondFiles"
                                                OnInvio={() =>  onPrint(true, BondData.Dato, true, false, detail.Numero)}
                                                OnClick={onClickPrint}
                                                OnErrore={OnApiError}/>
                                </Grid>
                            )}
                            {Number(detail.Numero) > 0 && (
                                <Grid item xs={12} md={2}>
                                    <_ButtonAPI Testo={Trad.Trad("Firma con marca")} Icona={<PrintIcon/>}
                                                URL="/api/File/GetPolicyBondFiles"
                                                OnInvio={() =>  onPrint(true, BondData.Dato, true, true, detail.Numero)}
                                                OnClick={onClickPrint}
                                                OnErrore={OnApiError}/>
                                </Grid>
                            )}
                            {Number(detail.ID_Appendice) > 0 && isDraft && (
                                <Grid item xs={12} md={2}>
                                    <_Button Testo={Trad.Trad("Aggiorna")}
                                             OnClick={toggleUpdate} Default={false}
                                             WithWrapper={false}/>
                                </Grid>
                            )}
                            {Number(detail.ID_Appendice) > 0 && (
                                <Grid item xs={12} md={2}>
                                    <_Button Testo={Trad.Trad("Elimina")}
                                             OnClick={toggleDelete} Default={false}
                                             WithWrapper={false}/>
                                </Grid>
                            )}
                            {Number(detail.ID_Appendice) > 0 && isDraft &&(
                                <Grid item xs={12} md={2}>
                                    <_Button Testo={Trad.Trad("Emetti")}
                                             OnClick={toggleRelease} Default={false}
                                             WithWrapper={false}/>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                    {index < addenda.length - 1 && <Divider light className={classes.divider}/>}
                    <Grid item container xs={12} spacing={3} justify="flex-end">
                        <Grid item xs={12} md={2}>
                            {index == addenda.length - 1 && <_ButtonAPI Testo={Trad.Trad("Salva appendici")}
                                                                          Attivo={Number(addenda[addenda.length - 1].ID_Appendice) == 0}
                                                                          URL="/api/addendum/Add"
                                                                          OnInvio={() => GetFormData(true, GetPolicyState(detail.ID_TipoAppendice))}
                                                                          OnClick={OnClickSaveAddenda}
                                                                          OnErrore={OnApiError}
                                                                          Default={false}/>}
                        </Grid>
                    </Grid>
                </div>
            ))}
        </>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/Bond/AddendaList.tsx